// Экран приветствия — выбор языка.
// Ставим data-lang на <html>; показ нужного экрана решает CSS (Wedding.styl).
const root = document.documentElement;

export function initHello() {
	document.addEventListener("click", (event) => {
		const langButton = event.target.closest("button[data-lang]");
		if (!langButton) return;

		root.setAttribute("data-lang", langButton.dataset.lang);
		window.scrollTo(0, 0);
	});
}
